<template>
  <main>
    <router-view :userID="userID" :finnakies="finnakies" />
  </main>
</template>
<script>
export default {
  props: { userID: String, env: Object, finnakies: String }
};
</script>